<template>
  <t-default-entry-sidebar
    v-if="sidebarInfo"
    :sidebar-list="sidebarInfo.sidebarList"
    :sidebar-current="sidebarInfo.sidebarCurrent"
    :heading="sidebarInfo.heading"
    :sub-heading="sidebarInfo.subHeading"
    :sidebar-heading="sidebarInfo.sidebarHeading"
    :sidebar-sub-heading="sidebarInfo.sidebarSubHeading"
    :class="componentClassName"
    :footer="false"
  >
    <template #alert>
      <a-alert title="COTOHA Call Centerへようこそ！" title-size="large" color="primary">
        <a-text>
          まず、基本設定の初期設定を行いましょう<br />
          （スキップしてあとから編集することもできます)
        </a-text>
        <a-text>まずはユーザーを招待しましょう</a-text>
      </a-alert>
    </template>
    <form class="t-walkthrough-invite-user__form">
      <div class="t-walkthrough-invite-user__fields">
        <div class="t-walkthrough-invite-user__instruction">
          <a-text>
            ユーザー数の上限は{{ maxUser }}人までです。<!--詳しくは
            <a-button variant="text" color="primary" target="_blank" :href="maxUserCountDetailUrl">こちら</a-button>-->
          </a-text>
        </div>
        <div class="t-walkthrough-invite-user__options">
          <m-user-invitation-radio
            v-if="isScreenReady"
            v-model="userInvitationMethod"
            v-model:user-list="userList"
            name="user-invitation-method"
            value="user-input"
            class="t-walkthrough-invite-user__option-field"
            :add-limit="addLimit"
            @reach-limit="reachLimit"
          />
          <!--          <m-user-invitation-upload-radio-->
          <!--            v-model="userInvitationMethod"-->
          <!--            v-model:upload-file="userUploadedFile"-->
          <!--            :template-url="userUploadTemplate"-->
          <!--            name="user-invitation-method"-->
          <!--            value="user-upload"-->
          <!--            class="t-walkthrough-invite-user__option-field"-->
          <!--          />-->
        </div>
        <!--        <div class="t-walkthrough-invite-user__otp-required">
          <a-checkbox v-model="isOtpRequired" label="ユーザーが参加する際、SMS認証を必須にする" />
          <a-button variant="text" :inline="true" icon="help-outline" icon-color="black" @click="handleHelpClick" />
        </div>-->
      </div>
      <!-- <div class="t-walkthrough-invite-user__pricing">
        <m-price-table title="現在の料金" :list="priceList" />
      </div> -->
      <div class="t-walkthrough-invite-user__buttons">
        <m-button-container>
          <a-button variant="block" color="primary" @click="handleSubmitForm">次へ</a-button>
          <!--          <a-button disabled variant="outlined" color="primary" @click="handleCancelClick">戻る</a-button>-->
          <a-button color="primary" class="t-walkthrough-invite-user__button-optional" @click="handleSkipClick"
            >スキップ</a-button
          >
          <a-button color="primary" class="t-walkthrough-invite-user__button-optional" @click="handleNotSettingClick"
            >初期設定はせずにホーム画面へ</a-button
          >
        </m-button-container>
      </div>
    </form>
    <!--<teleport to="body">
      <o-modal
        v-model:visible="helpDialogVisible"
        class="o-modal-help-dialog"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        @close="handleCloseHelpDialog"
      >
        <template #title>{{ currentHelpMessageTitle }}</template>
        <a-text>-->
    <!-- eslint-disable -->
          <!-- <span v-html="currentHelpMessageText" /> -->
          <!-- eslint-enable -->
    <!--</a-text>
      </o-modal>
    </teleport>-->

    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="walkthroughInviteUser_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-add-user-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text :center="true">
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <div v-if="addUserCheckModalVisible">
            <div class="content">
              <div class="inner">
                <a-button
                  id="no"
                  variant="outlined"
                  color="primary"
                  label="いいえ"
                  size="small"
                  @click="handleCloseModal"
                />
                <a-button id="yes" variant="block" color="primary" label="はい" size="small" @click="goNextPage" />
              </div>
            </div>
          </div>
          <div v-else>
            <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
          </div>
        </template>
      </o-modal>
    </teleport>

    <!-- For Trial Modal -->
    <teleport to="body">
      <o-modal
        id="walkthroughInviteUser_resultTrialModal"
        v-model:visible="resultModalVisibleTrial"
        class="o-modal-add-user-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text :center="true">
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <div class="content">
            <div class="inner">
              <a-button id="yes" variant="block" color="primary" label="はい" size="small" @click="goNextPageTrial" />
            </div>
          </div>
        </template>
      </o-modal>
    </teleport>
  </t-default-entry-sidebar>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import TDefaultEntrySidebar from '@/components/templates/default-entry-sidebar';
import AAlert from '@/components/atoms/alert';
import AText from '@/components/atoms/text';
// import ACheckbox from '@/components/atoms/checkbox';
import AButton from '@/components/atoms/button';
import MButtonContainer from '@/components/molecules/button-container';
import MUserInvitationRadio from '@/components/molecules/user-invitation-radio';
// import MUserInvitationUploadRadio from '@/components/molecules/user-invitation-upload-radio';
import OModal from '@/components/organisms/modal';
import MPriceTable from '@/components/molecules/price-table';
import { cloneDeep } from 'lodash';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { MAX_USER_PER_COMPANY, MAX_USER_PER_COMPANY_TRIAL, MAX_USER_COM_COMPANY } from '@/libs/constants';
import { POINT } from '@/libs/constants';
import { statusConst } from '@/libs/constants';
import { chkTrialCompanyID } from '@/libs/utils';

export default {
  name: 't-walkthrough-invite-user',
  components: {
    TDefaultEntrySidebar,
    AAlert,
    AText,
    // ACheckbox,
    AButton,
    MButtonContainer,
    MUserInvitationRadio,
    // MUserInvitationUploadRadio,
    //MPriceTable,
    OModal,
  },
  mixins: [customRequest, customValidate, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
    // sidebarInfo: {
    //   type: Object,
    //   default: null,
    // },
    // maxUserCount: {
    //   type: Number,
    //   default: 0,
    // },
    // maxUserCountDetailUrl: {
    //   type: String,
    //   default: '#',
    // },
    // userUploadTemplate: {
    //   type: String,
    //   default: '',
    // },
    // currentHelpMessageTitle: {
    //   type: String,
    //   default: null,
    // },
    // currentHelpMessageText: {
    //   type: String,
    //   default: null,
    // },
    // priceList: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // handleFormSubmit: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleSkipClick: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleNotSettingClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      sidebarInfo: {
        sidebarList: [{ label: 'ユーザー招待' }, { label: '営業時間設定' }, { label: '着信フローの設定' }],
        sidebarCurrent: 1,
        heading: 'ユーザー招待',
        subHeading: 'Step 1',
        sidebarSubHeading: 'Walk Through',
        sidebarHeading: '初期設定',
      },
      availableUserCount: 49,
      maxUserCountDetailUrl: '#',
      userUploadTemplate: 'https://support.staffbase.com/hc/en-us/article_attachments/360009197031/username.csv',
      priceList: [
        {
          title: '基本料金',
          price: '3,000',
          unit: '円 / 月',
        },
        {
          title: 'ユーザー料金',
          subtitle: '（1,000円×ユーザー数）',
          price: '58,000',
          unit: '円 / 月',
        },
      ],
      //     currentHelpMessageTitle: 'COTOHA Call Centerの着信フローとは？',
      //     currentHelpMessageText: `営業時間中に着信した際に、オペレーターが対応する前に自動音声のガイダンスを流して、お客様の用件に応じて適した担当者に電話を繋ぐ機能です。<br/>
      // <br/>
      // 例えば、「営業電話は1、問合せ内容は2」と割り振ると、お客様が押したプッシュ番号に応じて、事前に設定した担当者のみが着電するよう設定できます。外部の回線に電話を転送することも可能です。<br/>
      // <br/>
      // <div style="text-align:center;">
      //   <img src="https://via.placeholder.com/370x210.png?text=Help+Graphic+Here" />
      // </div>`,
      userInvitationMethod: 'user-input',
      userList: [],
      userUploadedFile: null,
      isOtpRequired: true,
      // helpDialogVisible: false,
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      companyID: this.$store.state.user.companyID,
      addUserCheckModalVisible: false,
      resultModalVisibleTrial: false,
      addLimit: 0, // 追加可能のユーザー数
      isTrial: false,
      isScreenReady: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-walkthrough-invite-user');
      return `${baseClassName} ${this.class}`.trim();
    },
    maxUser() {
      return this.companyID === POINT
        ? MAX_USER_COM_COMPANY
        : this.isTrial
        ? MAX_USER_PER_COMPANY_TRIAL
        : MAX_USER_PER_COMPANY;
    },
  },
  created() {
    this.isTrial = chkTrialCompanyID(this.companyID);
    this.calculateUserAddLimit();
  },
  methods: {
    calculateUserAddLimit() {
      this.postRequest('/idmgmt/getuserlist', { companyID: this.selectedCompanyID })
        .then(res => {
          if (!res.data) throw new Error('Fetch user list failed');
          const userCount = Object.keys(res.data).length;
          this.addLimit = this.maxUser - userCount;
          this.isScreenReady = true;
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    updateFirstVisitFlag(status = false) {
      this.postRequest('/walkthrough/update-firstVisitFlag', { status })
        .then(res => {
          if (res.status === 'success') {
            //console.log('firstVisitFlag is updated to', status);
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('検索'));
        });
    },
    handleSubmitForm(e) {
      e.preventDefault();
      // const payload = {
      //   method: this.userInvitationMethod,
      //   otp: this.isOtpRequired,
      // };
      // if (this.userInvitationMethod === 'user-input') {
      //   payload.userList = this.userList;
      // } else {
      //   payload.file = this.userUploadedFile;
      // }
      // this.handleFormSubmit(cloneDeep(payload));
      //console.log('ユーザー招待');
      // console.log(this.userList);
      this.handleUserInvitationAdd();
    },
    handleUserInvitationAdd() {
      let check = true;
      // const regexp =
      //   /^([ぁ-んァ-ヶーA-Za-zＡ-Ｚａ-ｚ0-9０-９ 　\u{3005}\u{3007}\u{303b}\u{3400}-\u{9FFF}\u{F900}-\u{FAFF}\u{20000}-\u{2FFFF}][\u{E0100}-\u{E01EF}\u{FE00}-\u{FE02}]?)+$/mu;
      if (this.userList.length <= 0) return this.showErrorModal(messageContent.requireAdd('ユーザー'));
      this.userList.forEach(user => {
        if (!this.addressCheck(user.userID)) {
          check = false;
          return this.showErrorModal(messageContent.requireInput('メールアドレス'));
        } else if (this.hasSpecialCharacterInObject(user)) {
          check = false;
          return this.showErrorModal(messageContent.hasSpecialCharacter);
        } else if (!user.username) {
          check = false;
          return this.showErrorModal(messageContent.requireInput('ユーザー名'));
        } else if (user.username.length > 41) {
          check = false;
          return this.showErrorModal(messageContent.requireUnderMaximumNumberOfCharacters('ユーザー名', 41));
        } else if (!this.hasSymbolCharacterInString(user.username)) {
          check = false;
          return this.showErrorModal(messageContent.requireNotSymbolCharacters('ユーザー名'));
        } else if (user.departmentInfo !== '' && !this.hasSymbolCharacterInString(user.departmentInfo)) {
          check = false;
          return this.showErrorModal(messageContent.requireNotSymbolCharacters('部署名'));
        }

        // Length check for メールアドレス, 部署
        let lengthCheck = this.emailLengthCheck(user.userID);
        if (!lengthCheck.status) {
          check = false;
          return this.showErrorModal(lengthCheck.message);
        }
        lengthCheck = this.departmentNameLengthCheck(user.departmentInfo);
        if (!lengthCheck.status) {
          check = false;
          return this.showErrorModal(lengthCheck.message);
        }
        // Underbar check for username
        const underbarCheck = this.fullnameUnderbarCheck(user.username, '名前');
        if (!underbarCheck.status) {
          check = false;
          return this.showErrorModal(underbarCheck.message);
        }
        // Only space check
        let onlySpaceChk = this.onlySpaceCheck(user.username, '名前');
        if (!onlySpaceChk.status) {
          check = false;
          return this.showErrorModal(onlySpaceChk.message);
        }
        onlySpaceChk = this.onlySpaceCheck(user.departmentInfo, '部署');
        if (!onlySpaceChk.status) {
          check = false;
          return this.showErrorModal(onlySpaceChk.message);
        }
        // Duplicate check
        let duplicateCount = -1;
        for (const urs of this.userList) {
          if (urs.userID === user.userID) duplicateCount++;
        }
        if (duplicateCount > 0) {
          check = false;
          return this.showErrorModal(messageContent.userIdDuplicateError(user.userID));
        }
        return '';
      });
      if (!check) return '';
      this.confirmUserAdd();
      return '';
    },
    // handleHelpClick() {
    //   this.helpDialogVisible = true;
    // },
    // handleCloseHelpDialog() {
    //   this.helpDialogVisible = false;
    // },
    handleFormSubmit(formData) {
      //console.log('ユーザー招待');
    },
    handleNotSettingClick() {
      this.updateFirstVisitFlag();
      this.$router.push({ name: 'Home' });
    },
    handleCancelClick() {},
    handleSkipClick() {
      // #3274 For Trial
      if (chkTrialCompanyID(this.companyID)) {
        this.showModalTrial(messageContent.alertTrialWalkThroughInUserAdd());
        return;
      }
      this.$router.push({ name: 'WTSelectBusinessHours' });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      this.addUserCheckModalVisible = false;
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
      this.addUserCheckModalVisible = false;
    },
    showModal(message) {
      this.resultModalVisible = true;
      this.resultModalContent = message;
      this.resultModalTitle = 'ユーザー追加';
    },
    confirmUserAdd() {
      if (this.userList.length > 0) {
        this.addUserCheckModalVisible = true;
        // #3274 For Trial
        if (chkTrialCompanyID(this.companyID)) {
          this.showModal(messageContent.notifyUserAddTrial());
        } else {
          this.showModal(messageContent.notifyUserAdd());
        }
      }
    },
    showModalTrial(message) {
      this.resultModalVisibleTrial = true;
      this.resultModalContent = message;
      this.resultModalTitle = 'ユーザー追加';
    },
    goNextPageTrial() {
      this.resultModalVisibleTrial = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      this.$router.push({ name: 'WTIvrUserGroup' });
    },
    goNextPage() {
      const formDataTmp = {
        companyID: this.selectedCompanyID,
        userList: this.userList,
      };
      this.postRequest('/idmgmt/create-from-walkthrough', formDataTmp)
        .then(e => {
          if (e.status === 'validationError') {
            this.showErrorModal(e.msg);
          } else if (e.status === statusConst.EXCEED_MAX_USER) {
            this.showErrorModal(messageContent.maxUser(this.maxUser));
          } else if (e.status === statusConst.EXCEED_TRIAL_MAX_USER) {
            this.showErrorModal(messageContent.requireTrialUserAdd(this.maxUser));
          } else if (e.status === 'success') {
            // Go to next page
            // #3274 For Trial
            if (chkTrialCompanyID(this.companyID)) {
              this.showModalTrial(messageContent.alertTrialWalkThroughInUserAdd());
              return;
            }
            this.$router.push({ name: 'WTSelectBusinessHours' });
          } else if (e.status === 'userExist') {
            this.showErrorModal(this.existItem(e.data.userID));
          } else {
            this.showErrorModal(messageContent.requireTry('追加'));
          }
          this.calculateUserAddLimit();
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('追加'));
        });
    },
    reachLimit(val) {
      if (val) {
        const item = this.isTrial ? `トライアル時は${this.maxUser}ID` : `${this.maxUser}ID`;
        this.showErrorModal(messageContent.reachUserCountLimit(item));
      }
    },
  },
};
</script>
